const initialState = {
  quote: {},
  hasError: false,
};

const initialStateForTest = {
  quote: {},
  hasError: false,
};

export default initialState;
export { initialStateForTest };
